import firebaseKit from "../firebase/firebaseKit";
import ChatMessage from "./ChatMessage";
import { ChatMessageEnums } from "./index";
import { refs, getRef } from "../firebase/firebaseRefKit";

export default class PrivateChatMessage extends ChatMessage {
  constructor({
    me = null,
    payload: {
      author,
      epoch = firebaseKit.util.getServerTimestamp(),
      message = "",
      timeStamp = new Date().toGMTString(),
      videoRoomSlug = null,
      kind = ChatMessageEnums.TEXT,
    },

    options = {},

    urlParams: { eventSlug, inboxUUID, firebaseID },
  }) {
    super(options);

    if (me) {
      this.author = {
        displayName: this._getDisplayName(me),
        userId: me?.user?.id,
        eventUserId: me?.id,
      };
    } else if (author) {
      this.author = this._camelCaseify(author);
    } else {
      throw new Error("No author specified for message");
    }

    this.videoRoomSlug = options.videoRoomSlug || videoRoomSlug;

    this.message = message;
    this.epoch = epoch;
    this.timeStamp = timeStamp;
    this.kind = options.kind || kind;

    this._urlParams = {
      eventSlug,
      inboxUUID,
      firebaseID,
    };

    this.type = "private";
  }

  _getInboxRef() {
    const { inboxUUID } = this._urlParams;
    if (!inboxUUID)
      throw new Error("Can't get Firebase ref without eventSlug and pageSlug");
    const ref = getRef(refs["private-messages"].inboxes.$inboxUUID.messages, {
      inboxUUID,
    });
    if (ref) return ref;
  }

  _getInboxBaseUrl() {
    return `private-messages/inboxes`;
  }

  _getPayload() {
    const { author, message, epoch, timeStamp, videoRoomSlug } =
      this;

    let payload = {
      author,
      message,
      epoch,
      timeStamp,
    };

    if (videoRoomSlug) payload.videoRoomSlug = videoRoomSlug;

    return payload;
  }
}
